import React from "react";
import "../styles/Layout.css";
import "../styles/Components.css";

const SidePanel = ({ side, punchCount, conditions }) => {
  const isSuccess = conditions.elbowPos && conditions.elbowStraight;
  const isDefensive =
    conditions.proximity && !conditions.elbowPos && !conditions.elbowStraight;

  const panelClasses = [
    "side-panel",
    isSuccess ? "success-bg" : "",
    isDefensive ? "defensive-bg" : "",
  ]
    .join(" ")
    .trim();

  return (
    <div id={`${side}-panel`} className={panelClasses}>
      <h3>{side.charAt(0).toUpperCase() + side.slice(1)} Side</h3>
      <div className="punch-count-container">
        <span className="punch-count-label">PUNCHES</span>
        <span id={`${side}-punch-count`} className="punch-count">
          {punchCount}
        </span>
      </div>
      <div className="metric-container" id={`${side}-proximity-container`}>
        <span>Hand in Proximity</span>
        <span
          className={`checkmark ${conditions.proximity ? "visible" : ""}`}
          id={`${side}-proximity-check`}
        >
          ✓
        </span>
      </div>
      <div className="metric-container" id={`${side}-elbow-pos-container`}>
        <span>Elbow Above Line</span>
        <span
          className={`checkmark ${conditions.elbowPos ? "visible" : ""}`}
          id={`${side}-elbow-pos-check`}
        >
          ✓
        </span>
      </div>
      <div className="metric-container" id={`${side}-elbow-straight-container`}>
        <span>Elbow Straightness</span>
        <span
          className={`checkmark ${conditions.elbowStraight ? "visible" : ""}`}
          id={`${side}-elbow-straight-check`}
        >
          ✓
        </span>
      </div>
    </div>
  );
};

export default SidePanel;
